import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Box, Link, Typography } from '@mui/material';
import { FrictionLessViewNoAccessContent } from '@procom-labs/common';
export var Footer = function(param) {
    var _param_showLinks = param.showLinks, showLinks = _param_showLinks === void 0 ? true : _param_showLinks;
    var t = useTranslation('main').t;
    var location = useLocation();
    var isFrictionLessView = location.pathname === FrictionLessViewNoAccessContent;
    return /*#__PURE__*/ _jsx(Box, {
        sx: {
            width: '100%',
            position: 'sticky',
            margin: 0,
            height: {
                xs: 'fit-content',
                md: 54
            },
            paddingBottom: 0,
            flexDirection: {
                xs: 'column',
                md: 'row'
            }
        },
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        children: /*#__PURE__*/ _jsx(Box, {
            display: "flex",
            alignItems: "center",
            columnGap: 1,
            sx: {
                marginLeft: {
                    md: 9,
                    xl: 12
                },
                marginBlock: {
                    md: 2
                }
            },
            children: showLinks && !isFrictionLessView && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Link, {
                        href: "/terms-of-use",
                        target: "_blank",
                        variant: "caption",
                        children: t('common.footer.termsOfUse')
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        display: "inline",
                        variant: "h5",
                        sx: {
                            marginTop: '2px',
                            color: function(theme) {
                                return theme.palette.grey[500];
                            }
                        },
                        children: '\u2022'
                    }),
                    /*#__PURE__*/ _jsx(Link, {
                        href: "/privacy-policy",
                        target: "_blank",
                        variant: "caption",
                        children: t('common.footer.privacyPolicy')
                    })
                ]
            })
        })
    });
};
